import instance from '@/api/instance'
import { iReportFilter } from '@/types/requests'
import { iOrderFile } from '@/types/responses'

export const orderFileUpload = (formData: FormData) => instance.post<iOrderFile>('orders/file-upload', formData, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

export const orderFileRemove = (id: number) => instance.post('orders/file-remove', { id })
export const orderFileDownload = (id: number) => instance.get('orders/file-download', {
  params: { id },
  responseType: 'blob',
  transformResponse: (data) => data
})
export const downloadReport = (params: iReportFilter) => instance.post('orders/report', params, {
  responseType: 'blob',
  transformResponse: (data) => data
})
export const switchSubmitted = (id: number, value: boolean) => instance.post('orders/submitted', { id, is_documents_submitted: value })
